(function () {
  if (window.__giftBagInitialized) return;
  window.__giftBagInitialized = true;

  const GIFT_VARIANT_ID = 47169384382717;
  const POLL_INTERVAL_MS = 3000;
  let isProcessing = false;

  function emitCartRefresh() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function hideWrapper() {
    const wrapper = document.querySelector('.gift-checkbox-wrapper');
    if (wrapper) {
      wrapper.classList.add('hidden');
    }
  }

  function showWrapper() {
    const wrapper = document.querySelector('.gift-checkbox-wrapper');
    if (wrapper) {
      wrapper.classList.remove('hidden');
    }
  }

  function hideWrapperWithDelay() {
    setTimeout(hideWrapper, 2000);
  }

  // בדוק מצב עגלה מהשרת
  async function getCartState() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const giftItem = cart.items.find(item => item.variant_id === GIFT_VARIANT_ID);
      const hasNonGiftItems = cart.items.some(item => item.variant_id !== GIFT_VARIANT_ID);
      return {
        giftInCart: !!giftItem,
        giftLineKey: giftItem ? giftItem.key : null,
        hasNonGiftItems
      };
    } catch (e) {
      return { giftInCart: false, giftLineKey: null, hasNonGiftItems: false };
    }
  }

  // הסר מתנה ועדכן UI אם אין מוצרים אחרים בעגלה
  async function removeGiftIfCartEmpty() {
    const state = await getCartState();

    if (!state.hasNonGiftItems) {
      hideWrapper();

      if (state.giftInCart && state.giftLineKey && !isProcessing) {
        isProcessing = true;
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: state.giftLineKey, quantity: 0 })
          });
          emitCartRefresh();
        } catch (e) {
          // שגיאה שקטה - ננסה שוב בפולינג הבא
        }
        isProcessing = false;
      }
    }
  }

  async function addGift() {
    if (isProcessing) return;

    const state = await getCartState();

    // אם אין מוצרים רגילים בעגלה - אל תוסיף
    if (!state.hasNonGiftItems) {
      const checkbox = document.getElementById('gift-bag-checkbox');
      if (checkbox) checkbox.checked = false;
      hideWrapper();
      return;
    }

    if (state.giftInCart) {
      hideWrapperWithDelay();
      return;
    }

    isProcessing = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: GIFT_VARIANT_ID,
          quantity: 1
        })
      });

      if (response.ok) {
        emitCartRefresh();
      } else {
        const checkbox = document.getElementById('gift-bag-checkbox');
        if (checkbox) checkbox.checked = false;
      }
    } catch (e) {
      const checkbox = document.getElementById('gift-bag-checkbox');
      if (checkbox) checkbox.checked = false;
    }

    isProcessing = false;
  }

  async function removeGift() {
    if (isProcessing) return;

    const state = await getCartState();
    if (!state.giftInCart || !state.giftLineKey) return;

    isProcessing = true;

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: state.giftLineKey,
          quantity: 0
        })
      });

      if (response.ok) {
        emitCartRefresh();
      } else {
        const checkbox = document.getElementById('gift-bag-checkbox');
        if (checkbox) checkbox.checked = true;
      }
    } catch (e) {
      const checkbox = document.getElementById('gift-bag-checkbox');
      if (checkbox) checkbox.checked = true;
    }

    isProcessing = false;
  }

  // Handler לצ'קבוקס - נגיש מבחוץ
  window.handleGiftCheckbox = function (checkbox) {
    if (checkbox.checked) {
      addGift();
      hideWrapperWithDelay();
    } else {
      removeGift();
    }
  };

  // אחרי כל ריענון עגלה - בדוק אם יש מוצרים רגילים
  document.addEventListener('cart:refresh', async () => {
    setTimeout(async () => {
      const state = await getCartState();
      if (!state.hasNonGiftItems) {
        hideWrapper();
        // אם המתנה עדיין בעגלה - הסר אותה
        if (state.giftInCart && state.giftLineKey && !isProcessing) {
          isProcessing = true;
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: state.giftLineKey, quantity: 0 })
            });
          } catch (e) {}
          isProcessing = false;
        }
      } else if (state.giftInCart) {
        hideWrapper();
      }
    }, 100);
  });

  // פולינג תמידי - בדיקה כל POLL_INTERVAL_MS מילישניות
  setInterval(removeGiftIfCartEmpty, POLL_INTERVAL_MS);

  // בדיקה התחלתית
  (async () => {
    const state = await getCartState();
    if (!state.hasNonGiftItems) {
      hideWrapper();
      if (state.giftInCart && state.giftLineKey) {
        isProcessing = true;
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: state.giftLineKey, quantity: 0 })
          });
          emitCartRefresh();
        } catch (e) {}
        isProcessing = false;
      }
    } else if (state.giftInCart) {
      hideWrapper();
    }
  })();
})();
